import { Stack } from "@mantine/core"
import { useState } from "react"

import { findBouncedEmailsFilterType } from "@tfg/types/schemas/admin"

import { DataFetchWrapper } from "~/components/DataFetchWrapper"
import { BouncedEmailsTable } from "~/pages/Admin/Exports/BouncedEmails/BouncedEmailsTable"
import { useGetBouncedEmails } from "~/pages/Admin/Exports/BouncedEmails/hooks/useGetBouncedEmails"

export type BouncedEmailsFilters = Omit<findBouncedEmailsFilterType, "date"> & {
  date: Date | null
}

export function BouncedEmailsContainer() {
  const [filters, setFilters] = useState<BouncedEmailsFilters>({
    event: undefined,
    inviterOrganizationId: undefined,
    supplierEmail: undefined,
    date: null,
  })
  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 15 })
  const query = useGetBouncedEmails({
    fetchDataOptions: {
      ...pagination,
    },
    filters,
  })

  return (
    <Stack>
      <DataFetchWrapper query={query}>
        {({ data }) => (
          <BouncedEmailsTable
            bouncedEmails={data}
            setFilters={setFilters}
            filters={filters}
            setPagination={setPagination}
            pagination={pagination}
          />
        )}
      </DataFetchWrapper>
    </Stack>
  )
}
